import useActionReducer from '@admin/hooks/use_action_reducer'
import Authorized from './authorized'
import * as actions from './actions'
import PropTypes from 'prop-types'
import reducer from './reducer'
import React from 'react'

const AuthorizedContainer = (props) => {

  const [state, handlers] = useActionReducer({
    display_name: 'authorized',
    actions,
    props,
    reducer
  })

  const mergedProps = {
    ...props,
    ...state,
    ...handlers
  }

  return <Authorized { ...mergedProps } />

}

AuthorizedContainer.propTypes = {}

export default AuthorizedContainer